/**
 * Show the current Bootstrap breakpoint and screen dimensions for development purposes.
 *
 * @param {number} size
 */
const showScreenInfo = ( size: number = 10 ) =>
{
	const body        = document.querySelector( 'body' );
	const container   = document.createElement( 'div' );
	const widthElem   = document.createElement( 'div' );
	const breakpoints = {
		xs:  'd-block d-sm-none',
		sm:  'd-none d-sm-block d-md-none',
		md:  'd-none d-md-block d-lg-none',
		lg:  'd-none d-lg-block d-xl-none',
		xl:  'd-none d-xl-block d-xxl-none',
		xxl: 'd-none d-xxl-block',
	};

	container.style.cssText = `
		position: fixed;
		top: 0;
		left: 0;
		color: #fff;
		font-size: ${size}px;
		display: flex;
		z-index: 9999;
		background: rgba(0,0,0,0.5);
		font-family: 'Fira Code', monospace;
		font-weight: normal;
		line-height: 1;
		text-shadow: #000 0 0 2px;
		backdrop-filter: blur(3px);
	`;

	widthElem.style.cssText = `
		padding: 5px 10px;
	`;

	Object.keys( breakpoints ).forEach( name =>
	{
		const div = document.createElement( 'div' );

		div.className     = breakpoints[name];
		div.innerHTML     = name;
		div.style.cssText = `
			padding: 5px 10px;
			background: rgba(0,0,0,0.4);
		`;

		container.appendChild( div );
	} );

	if (body instanceof HTMLElement) {

		body.appendChild( container );
		container.appendChild( widthElem );

		updateSize( widthElem );
		window.addEventListener( 'resize', () => updateSize( widthElem ) );
	}
};


/**
 *
 * @param {HTMLElement} widthElem
 */
const updateSize = ( widthElem: HTMLElement ) =>
{
	widthElem.innerHTML = `${window.innerWidth} x ${window.innerHeight}`;
};


/**
 *
 */
export default showScreenInfo;